import {
  collection, query, getDocs, deleteDoc, doc, orderBy, limit,
} from 'firebase/firestore';
import { db } from '../lib/firebase/app';
import type { LocationDrop } from '../types';

const COL = 'locationDrops';

export async function getAllDrops(): Promise<LocationDrop[]> {
  const q = query(collection(db, COL), orderBy('createdAt', 'desc'), limit(200));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() } as LocationDrop));
}

export async function deleteDrop(dropId: string): Promise<void> {
  await deleteDoc(doc(db, COL, dropId));
}
